function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.438 7c.218 0 .421.04.609.117.187.078.354.185.5.32.146.136.255.3.328.493.073.192.115.398.125.617a1.567 1.567 0 01-.453 1.101L9.945 15.25 7 15.984l.734-2.945 5.602-5.594c.151-.15.32-.263.508-.336.187-.073.385-.109.594-.109zM15 8.547c0-.167-.052-.3-.156-.399A.566.566 0 0014.438 8a.713.713 0 00-.211.031.4.4 0 00-.18.117L8.64 13.555l-.266 1.054 1.055-.265 5.406-5.399A.542.542 0 0015 8.547zM2 1v14h3.953l-.242 1H1V0h8.71L14 4.29v1.5a2.69 2.69 0 00-.516.116 2.33 2.33 0 00-.484.242V5H9V1H2zm8 .71V4h2.29L10 1.71zM11 7v1H4V7h7zm-7 5v-1h4.008l-1 1H4zm6.008-3l-1 1H4V9h6.008z",
  fill: "#9EA2FF"
});

function SvgSendFormIconDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSendFormIconDark;